function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { sdkLogger } from '../../../logger';
import { AdMetadataSource } from '../../adverts/common';
import { getAdBreakForAd } from '../../../utils/ad-break-utils';
export var ConvivaAdInsights = /*#__PURE__*/ function() {
    "use strict";
    function ConvivaAdInsights(convivaVideoAnalytics, convivaAddonInfo, session, sessionItem, metaAdapter) {
        _class_call_check(this, ConvivaAdInsights);
        _define_property(this, "convivaVideoAnalytics", void 0);
        _define_property(this, "convivaAddonInfo", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "metaAdapter", void 0);
        _define_property(this, "availableAdBreaks", void 0);
        _define_property(this, "convivaAdAnalytics", void 0);
        _define_property(this, "activeAdBreak", void 0);
        _define_property(this, "activeAd", void 0);
        _define_property(this, "currentState", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "playoutData", void 0);
        this.convivaVideoAnalytics = convivaVideoAnalytics;
        this.convivaAddonInfo = convivaAddonInfo;
        this.session = session;
        this.sessionItem = sessionItem;
        this.metaAdapter = metaAdapter;
        this.availableAdBreaks = [];
        this.convivaAdAnalytics = null;
        this.activeAdBreak = null;
        this.activeAd = null;
        this.currentState = {
            state: null,
            bitrate: null,
            resolution: null
        };
        this.logger = sdkLogger.withContext('AdInsights');
        this.listenToAdEvents();
    }
    _create_class(ConvivaAdInsights, [
        {
            key: "reportFailed",
            value: function reportFailed(errorMsg) {
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdFailed(errorMsg);
                    this.logger.verbose('Report ad failed', errorMsg);
                }
            }
        },
        {
            key: "reportState",
            value: function reportState(playerState) {
                this.currentState.state = playerState;
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.PLAYER_STATE, playerState);
                    this.logger.verbose('Report ad state', playerState);
                }
            }
        },
        {
            key: "reportBitrate",
            value: function reportBitrate(bitrateKbps) {
                this.currentState.bitrate = bitrateKbps;
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.BITRATE, bitrateKbps);
                    this.logger.verbose('Report ad bitrate', bitrateKbps);
                }
            }
        },
        {
            key: "reportSeekStarted",
            value: function reportSeekStarted(positionMs) {
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.SEEK_STARTED, positionMs);
                    this.logger.verbose('Report ad seek started', positionMs);
                }
            }
        },
        {
            key: "reportSeekStartedWorkaround",
            value: function reportSeekStartedWorkaround() {
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.SEEK_STARTED);
                    this.logger.verbose('Report ad seek started workaround');
                }
            }
        },
        {
            key: "reportSeekEnded",
            value: function reportSeekEnded() {
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.SEEK_ENDED);
                    this.logger.verbose('Report ad seek ended');
                }
            }
        },
        {
            key: "reportPlayHeadTime",
            value: function reportPlayHeadTime(positionMs) {
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.PLAY_HEAD_TIME, positionMs);
                    this.logger.verbose('Report ad play head time', positionMs);
                }
            }
        },
        {
            key: "reportVideoResolution",
            value: function reportVideoResolution(resolution) {
                var width = resolution.width, height = resolution.height;
                this.currentState.resolution = {
                    width: width,
                    height: height
                };
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.reportAdMetric(Conviva.Constants.Playback.RESOLUTION, width, height);
                    this.logger.verbose('Report ad video resolution', width, height);
                }
            }
        },
        {
            key: "release",
            value: function release() {
                this.activeAd = null;
                if (this.convivaAdAnalytics) {
                    this.convivaAdAnalytics.release();
                    this.convivaAdAnalytics = null;
                    this.logger.verbose('Release');
                }
            }
        },
        {
            key: "updatePlayoutData",
            value: function updatePlayoutData(playoutData) {
                this.playoutData = playoutData;
            }
        },
        {
            key: "buildAdAnalytics",
            value: function buildAdAnalytics() {
                this.convivaAdAnalytics = Conviva.Analytics.buildAdAnalytics(this.convivaVideoAnalytics);
                this.logger.verbose('Build video ad analytics');
            }
        },
        {
            key: "ensureReportedMetrics",
            value: function ensureReportedMetrics() {
                var _this_currentState = this.currentState, state = _this_currentState.state, bitrate = _this_currentState.bitrate, resolution = _this_currentState.resolution;
                if (state !== null) {
                    this.reportState(state);
                }
                if (bitrate !== null) {
                    this.reportBitrate(bitrate);
                }
                if (resolution !== null) {
                    this.reportVideoResolution(resolution);
                }
            }
        },
        {
            key: "init",
            value: function init() {
                this.buildAdAnalytics();
                this.setAdPlayerInfo();
            }
        },
        {
            key: "listenToAdEvents",
            value: function listenToAdEvents() {
                var _this = this;
                this.session.onAdBreakDataReceived(function(adBreaks) {
                    _this.availableAdBreaks = adBreaks;
                });
                this.session.onAdBreakStarted(function(adBreak) {
                    _this.activeAdBreak = adBreak;
                });
                this.session.onAdBreakFinished(function(_adBreak) {
                    _this.activeAdBreak = null;
                });
                this.session.onAdTrackingReceived(function(adBreaks) {
                    _this.availableAdBreaks = adBreaks;
                    var activeAd = _this.activeAd;
                    if (activeAd) {
                        var activeAdBreak = getAdBreakForAd(activeAd, adBreaks);
                        // If we started an ad with only partial data, we couldn't report ad started then, do it now
                        if (activeAdBreak.metadataSource === AdMetadataSource.Manifest) {
                            var updatedAd = activeAdBreak === null || activeAdBreak === void 0 ? void 0 : activeAdBreak.ads.find(function(ad) {
                                return !('adInsights' in ad) && ad.id === activeAd.id;
                            });
                            if (updatedAd) {
                                _this.reportAdStarted(updatedAd);
                            }
                        }
                    }
                });
                this.session.onAdFinished(function(_ad) {
                    _this.reportAdEnded();
                });
                this.session.onAdStarted(function(ad) {
                    _this.reportAdStarted(ad);
                });
                this.logger.verbose('Listen to ad events');
            }
        },
        {
            key: "reportAdEnded",
            value: function reportAdEnded() {
                var _this_convivaAdAnalytics;
                (_this_convivaAdAnalytics = this.convivaAdAnalytics) === null || _this_convivaAdAnalytics === void 0 ? void 0 : _this_convivaAdAnalytics.reportAdEnded();
                this.logger.verbose('Report ad ended');
                this.release();
            }
        },
        {
            key: "reportAdStarted",
            value: function reportAdStarted(ad) {
                var _this_activeAdBreak;
                this.activeAd = ad;
                var adBreak = ((_this_activeAdBreak = this.activeAdBreak) === null || _this_activeAdBreak === void 0 ? void 0 : _this_activeAdBreak.id) === ad.adBreakId ? this.activeAdBreak : getAdBreakForAd(ad, this.availableAdBreaks);
                // Don't report partial ads/ad breaks
                if (adBreak && adBreak.metadataSource === AdMetadataSource.Manifest) {
                    return;
                }
                this.init();
                var adInfo = this.metaAdapter.adaptAdTags(this.sessionItem, this.playoutData, this.convivaAddonInfo, this.availableAdBreaks, ad, this.logger);
                this.convivaAdAnalytics.reportAdStarted(adInfo);
                this.logger.verbose('Report ad started', adInfo);
                this.ensureReportedMetrics();
            }
        },
        {
            key: "setAdPlayerInfo",
            value: function setAdPlayerInfo() {
                var adPlayerInfo = this.metaAdapter.adaptPlayerInfo(this.convivaAddonInfo);
                this.convivaAdAnalytics.setAdPlayerInfo(adPlayerInfo);
                this.logger.verbose('Set ad player info', adPlayerInfo);
            }
        }
    ]);
    return ConvivaAdInsights;
}();

//# sourceMappingURL=conviva-ad-insights.js.map